import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'app-custom-snackbar',
    template: `
		<div class="snackbar-container" [ngClass]="data.className">
			<mat-icon class="snack-icon">{{ data.icon }}</mat-icon>
			<span class="snack-message">{{ data.message }}</span>
		</div>
	`,
    styles: [`
		.snackbar-container {
			display: flex;
			align-items: center;
			gap: 8px;
		}
		.snack-icon {
			font-size: 20px;
		}
		.snack-message {
			flex: 1;
		}
	`]
})
export class CustomSnackbarComponent {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) { }
}
